import { render } from "./BusinessCardList.vue?vue&type=template&id=6f568f2c"
import script from "./BusinessCardList.vue?vue&type=script&lang=js"
export * from "./BusinessCardList.vue?vue&type=script&lang=js"

import "./BusinessCardList.vue?vue&type=style&index=0&id=6f568f2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__